export const FLAVORS = [
  "Atomic",
  "BBQ",
  "Cajun",
  "Default",
  "GarlicParm",
  "Hawaiian",
  "LemonPepper",
  "LouisianaRub",
  "MangoHabanero",
  "MildGreen",
  "OriginalHot",
  "SKQ"
];
